import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

import { BehaviorSubject, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import SearchEventRequest from '../models-internal/search-event-request';
import TrackedEvent from '../models/tracked-event';
import { FileDownloadService } from './file-download.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private routerEvents$: Subscription;

  public get precannedBookingEventLogComments() {
    return {
      //Landowner Confirmation
      '3': ['Spoke with landowner', 'Other'],
      //Landowner Confirmation Attempt
      '4': ['Left voice message', 'Called no answer', 'Other'],
      //Member Feedback
      '6': [],
      //Landowner Feedback
      '7': [],

      // Reservation Modified
      '5': [],
    };
  }

  /**
   * A flag for showing developer comments (elements with the class "dev-comment")
   */
  public showDevComments = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private fileDownloadService: FileDownloadService,
    private router: Router,
    private route: ActivatedRoute    
  ) {
    this.routerEvents$ = router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationEnd) {
        this.onNavigationEnd(routerEvent);
      }
    });
  }

  private onNavigationEnd(routerEvent: NavigationEnd) {
    
    if (this.route && this.route.snapshot && this.route.snapshot.queryParams) {

      // sniff the query string
      Object.keys(this.route.snapshot.queryParams).forEach((key) => {
        // console.log(`from './log.service'.onNavigationEnd key:`, key);
        // console.log(`from './log.service'.onNavigationEnd value:`, this.route.snapshot.queryParams[key]);

        if (key.toLowerCase() === 'devcomments') {
          if (this.route.snapshot.queryParams[key].toLowerCase() === 'true') {
            this.showDevComments.next(true);
            
          } else {
            this.showDevComments.next(false);
            
          }
        }
      });
    }
  }

  public downloadCurrentLog() {
    const url = 'api/log/download/current';

    return this.fileDownloadService.downloadFile(url);
  }

  public addTrackedEvent(trackEvent: TrackedEvent) {
    if (trackEvent && trackEvent.userAccountId === 0) {
      throw 'Missing User Account ID';
    }

    return this.http.post('events/add', trackEvent).pipe(
      catchError((error) => {
        const payload = error && typeof error.json === 'function' ? error.json() : (error && (error.error ?? error));
        return throwError(() => payload);
      })
    );
  }

  public get verboseLogging(): boolean {
    if (localStorage.getItem('loggingLevel') && localStorage.getItem('loggingLevel').startsWith('v')) {
      return true;
    }
    return false;
  }

  public searchEvents(request: SearchEventRequest) {
    return this.http.post<any[]>('log/events/combined', request);
  }
}
